import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { uid } from 'react-uid';
import Grid from '@material-ui/core/Grid';
import { Sortable } from '@shopify/draggable';
import u from 'umbrellajs';
import _e from 'common/localeUtil';
import { ALL_WIDGETS, checkElement2, getWidgetURL } from '../utils';

// const useStyles = makeStyles(() => ({}));

// const getWidgetsFromIds = selectedWidgetIds => {
// 	const selectedWidgets = [];
// 	selectedWidgetIds.forEach(widgetId => {
// 		ALL_WIDGETS.forEach(widget => {
// 			if (widget.id === widgetId) {
// 				selectedWidgets.push(widget);
// 			}
// 		});
// 	});
//
// 	return selectedWidgets;
// };

const getRemainingWidgetsFromIds = selectedWidgetIds => {
	const remainingWidgets = [];
	ALL_WIDGETS().forEach(widget => {
		if (!selectedWidgetIds.includes(widget.id)) {
			remainingWidgets.push(widget);
		}
	});
	return remainingWidgets;
};

const renderEachWidget = (widget, handleClickCallback, buttonLabel, currentWidgetId) => {
	const { id, image, title, subtitle } = widget;

	if (id.includes('availableslot')) {
		return (
			<div
				className={`column each-section section-already-selected availableslot`}
				id={id}
				title={title}
			>
				<div>
					<div className="title-availableslot">Available slot</div>
					<div className="subtitle-dragwidgethere">Add widget here</div>
				</div>
			</div>
		);
	}

	if (id.includes('dummy')) {
		return (
			<div className={`column each-section section-already-selected`} id={id}>
				<div className="each-section-image">
					<img src={image} alt="image" />
				</div>
				<div className="each-section-title" />
				<div className="each-section-subtitle" />
				<div className="each-section-buttons">
					<div className="already-selected">{_e('coming_soon')}</div>
				</div>
			</div>
		);
	}

	const handleClickPreview = widget_ => () => {
		const realURL = getWidgetURL(widget_);
		window.open(realURL, '_blank');
	};
	return (
		<div className={`column each-section`} id={id} title={title}>
			<div className="each-section-image">
				<img src={image} alt="image" />
			</div>
			<div className="each-section-title">{title}</div>
			<div className="each-section-subtitle">{subtitle}</div>
			<div className="each-section-buttons">
				<a
					role={`presentation`}
					onClick={currentWidgetId === id ? () => {} : handleClickCallback(id)}
				>
					{currentWidgetId === id ? 'Current' : buttonLabel}
				</a>
				<a
					role={`presentation`}
					className="button-preview"
					onClick={handleClickPreview(widget)}
				>
					{_e('preview')}
				</a>
			</div>
		</div>
	);
};

const WidgetsDragDrop = ({
	selectedWidgetIds,
	widgetContainerId,
	// handleRemoveClickCallback,
	handleAddClickCallback,
	onDragDropCallback
}) => {
	const currentWidgetId = widgetContainerId ? widgetContainerId.substring(1) : null;
	// const generateAvailableSlots = () => {
	// 	const availableslots = [];
	// 	for (let i = 1; i <= 3 - selectedWidgetIds.length; i += 1) {
	// 		availableslots.push(`availableslot${i}`);
	// 	}
	//
	// 	return (
	// 		<>
	// 			{availableslots.map(slot => {
	// 				return (
	// 					<Grid item key={uid(slot)} sm={4} className={`availableslot`}>
	// 						{renderEachWidget({ id: slot })}
	// 					</Grid>
	// 				);
	// 			})}
	// 		</>
	// 	);
	// };

	const getAllSelectedWidgets = () => {
		const sectionSelector = '.allWidgetsWrapper.selectedWidgets';
		// Test
		// u(`${sectionSelector} .each-section`).each(node => {
		// 	const widgetId = u(node).attr('id');
		// 	console.log('WidgetsDragDrop getAllSelectedWidgets ', widgetId);
		// });
		return checkElement2(`${sectionSelector}:not([class^="draggable"])`).then(() => {
			const selectedWidgetIds_ = [];
			u(`${sectionSelector} .each-section`).each(node => {
				const widgetId = u(node).attr('id');
				// console.log('WidgetsDragDrop addDragDropForWidget', widgetId);
				if (!widgetId.includes('availableslot')) {
					selectedWidgetIds_.push(widgetId);
				}
			});
			console.log('WidgetsDragDrop addDragDropForWidget', selectedWidgetIds_);
			return selectedWidgetIds_;
		});
	};

	const addDragDropForWidget = sectionSelector => {
		// Make sections draggable
		const drag = new Sortable(document.querySelectorAll(sectionSelector), {
			draggable: '.eachWidget-draggable'
		});

		drag.on('sortable:stop', () => {
			// console.log('WidgetsDragDrop sortable:stop', e);

			checkElement2(`${sectionSelector}:not([class^="draggable"])`).then(() => {
				getAllSelectedWidgets().then(selectedWidgetIds_ => {
					onDragDropCallback(selectedWidgetIds_);
				});
			});
		});
		document.ontouchmove = function(event) {
			event.preventDefault();
		};
	};

	useEffect(() => {
		console.log('WidgetsDragDrop useEffect');
	});

	useEffect(() => {
		console.log('WidgetsDragDrop useEffect once');
		checkElement2('.section-content').then(() => {
			addDragDropForWidget('.allWidgetsWrapper.selectedWidgets');
		});
	}, []);

	const renderRemainingWidgets = () => {
		const remainingWidgets = getRemainingWidgetsFromIds(selectedWidgetIds);
		return remainingWidgets.map(widget => {
			if (!selectedWidgetIds.includes(widget.id) && widget.id !== currentWidgetId) {
				let className = 'eachWidget';
				if (!widget.id.includes('dummy')) {
					className = 'eachWidget-draggable';
				}
				return (
					<Grid item key={uid(widget)} sm={4} className={className}>
						{renderEachWidget(
							widget,
							handleAddClickCallback,
							_e('select'),
							currentWidgetId
						)}
					</Grid>
				);
			}
			return <></>;
		});
	};
	return (
		<>
			<div className="each-widgets-section section-remaining">
				<div className="title-wrapper">
					<div className="widget-title">{_e('add_widgets')}</div>
					<div className="widget-subtitle">{_e('choose_widgets')}</div>
				</div>

				<Grid container spacing={2} className="allWidgetsWrapper remainingWidgets">
					{renderRemainingWidgets()}
				</Grid>
			</div>
		</>
	);
};

WidgetsDragDrop.propTypes = {
	widgetContainerId: PropTypes.string,
	selectedWidgetIds: PropTypes.array,
	// handleRemoveClickCallback: PropTypes.func,
	handleAddClickCallback: PropTypes.func,
	onDragDropCallback: PropTypes.func
};

export default WidgetsDragDrop;
